// extracted by mini-css-extract-plugin
module.exports = {"tab":"GameDescription_tab__S_6Ns","panel":"GameDescription_panel__cP82U"};